import React from "react";

// Example PDF links (replace these with your actual PDF URLs)

const pdfLinks = {
    "Automatic Payment Authorization Form":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Automatic%20Payment%20Authorization%20Form.pdf",
    "Borrower Certification of Business Purpose":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Borrower%20Business%20Purpose%20Certification.pdf",
    "Borrower Contact Consent Form":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Borrower%20Contact%20Consent%20Form.pdf",
    "Borrower Occupancy Certification":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Borrower%20Occupancy%20Certification.pdf",
    "Business Narrative Form":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Business%20Narrative%20Form.pdf",
    "Condominium Reference Guide":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Condominium%20Reference%20Guide%2008-04-2025.pdf",
    "Consent of Spouse":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Consent%20of%20Spouse.pdf",
    "Full Review Condo Questionnaire":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Condo%20Questionnaire%20Full%20Review.pdf",
    "Guideline Exception Form":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Correspondent%20Guideline%20Exception%20Form.pdf",
    "Limited Review Condo Questionnaire":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Limited%20Review%20Condo%20Questionnaire.pdf",
    "LLC Multiple Member Certificate":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/LLC%20Borrowing%20Cert-Multiple%20Members.pdf",
    "LLC Single Member Certificate":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/LLC%20Borrowing%20Cert-Single%20Member.pdf",
    "Loan Update Request Form":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Loan%20Update%20Request%20Form.pdf",
    "Quick Reference Guide":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Corr%20Quick%20Reference%20Guide.pdf",
    "Personal Guaranty":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/Personal%20Guaranty.pdf",
    "UW LSS":"https://21505619.fs1.hubspotusercontent-na1.net/hubfs/21505619/Correspondent/Forms/UW%20LSS.pdf"
};

const correspondentForms = [
    {
        title: "Section 1",
        items: [
            "Automatic Payment Authorization Form",
            "Borrower Certification of Business Purpose",
            "Borrower Contact Consent Form",
            "Borrower Occupancy Certification",
            "Business Narrative Form",
            "Condominium Reference Guide",
            "Consent of Spouse",
            "Full Review Condo Questionnaire",
            "Guideline Exception Form"
        ],
    },
    {
        title: "Section 2",
        items: [
            "Limited Review Condo Questionnaire",
            "LLC Multiple Member Certificate",
            "LLC Single Member Certificate",
            "Loan Update Request Form",
            "Quick Reference Guide",
            "Personal Guaranty",
            "UW LSS"
        ],
    },
];

const openPdf = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
};

const alwaysLink = [
    'Super Jumbo Full/Alt-Doc',
    'Main Guidelines'
];
function splitBoldNormal(text) {
    // Special case: always hyperlink these
    if (alwaysLink.includes(text)) {
        return { bold: null, normal: text, forceLink: true };
    }
    // Split at last ' - ' (space-dash-space)
    const idx = text.lastIndexOf(' - ');
    if (idx === -1) return { bold: text, normal: null };
    return {
        bold: text.slice(0, idx),
        normal: text.slice(idx + 3)
    };
}

const Forms = () => (
    <div
        style={{
            width: '100%',
            fontFamily: 'ProximaNova-Regular, Helvetica, Arial, SansSerifFLF, sans-serif',
            color: '#23272f',
            marginTop: '40px',
        }}
    >
        <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginBottom: 32 }}>
            {/* Correspondent Forms Tile */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 520, paddingTop: '32px' }}>
                <h2 style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '2.5rem', margin: 0, letterSpacing: 0.5, lineHeight: 1.1 }}>
                    Correspondent Forms
                </h2>
                <div
                    style={{
                        background: '#fff',
                        borderRadius: '24px',
                        boxShadow: '0 2px 16px #0001',
                        padding: '32px',
                        minWidth: '420px',
                        marginTop: 16,
                        // no width: 100% or boxSizing here, keep original card size
                    }}
                >
                    <div style={{ display: 'flex', gap: '40px', marginTop: '24px' }}>
                        {correspondentForms.map((section) => (
                            <div key={section.title}>
                                {/* <h3 style={{ fontWeight: "bold", fontSize: "1.2rem" }}>{section.title}</h3> */}
                                <ul style={{ listStyle: "none", padding: 0, color: '#23272f' }}>
                                    {section.items.map((item) => (
                                        <li key={item} style={{ margin: "12px 0", display: "flex", alignItems: "center" }}>
                                            <img src="/content/Images/guidelinedoc.svg" alt="doc" style={{ marginRight: "12px", width: 26, height: 26, display: 'inline-block', verticalAlign: 'middle' }} />
                                            <a
                                                href={pdfLinks[item]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="matrix-link"
                                                style={{ fontWeight: 600 }}
                                            >
                                                {item}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    </div>
);

export default Forms;